    <!-- Planner Title -->
    <div class="wrap uk-margin-bottom">
        <div uk-grid class="uk-margin-bottom remove-grid-ml-pl">
            <div class="uk-width-expand">
                <span class="main-title bold">Planning </span>
                <a uk-slidenav-previous class="vertical-align-super" (click)="navigate('prev')"></a>
                <span class="main-title"> {{ titleFormatted }}</span>
                <a uk-slidenav-next class="vertical-align-super" (click)="navigate('next')"></a>
            </div>
        </div>
    </div>

    <!-- Full-width main content (almost edge-to-edge) -->
    <div class="planner-body-full">
        <!-- Toolbar -->
        <div class="uk-margin-bottom remove-grid-ml-pl" uk-grid>
            <div class="uk-width-1-1">
                <div class="uk-flex uk-flex-middle uk-flex-between planner-inset">
                    <!-- LEFT: Add button or create-mode label -->
                    <div class="uk-flex uk-flex-middle planner-controls-group">
                        <ng-container *ngIf="showCreateButton && createModeLabel">
                            <span class="mode-label mode-label--blue">
                                {{ createModeLabel }}
                            </span>
                            <button class="button back-button" type="button"
                                (click)="deactivateCreate.emit()">Désactiver</button>
                        </ng-container>

                        <ng-container *ngIf="showCreateButton && !createModeLabel">
                            <button class="button bold" type="button" (click)="addEventClick.emit()">Ajouter un
                                événement</button>
                        </ng-container>
                    </div>

                    <!-- RIGHT: Zoom + Today + loader -->
                    <div class="uk-flex uk-flex-middle planner-controls-group">
                        <div class="uk-flex uk-flex-middle planner-zoom-group">
                            <button class="uk-button uk-button-small uk-border-pill round-button"
                                [class.round-button-toggle]="zoomLevel === 'day'" (click)="setZoom('day')">Jour</button>

                            <button class="uk-button uk-button-small uk-border-pill round-button"
                                [class.round-button-toggle]="zoomLevel === 'week'"
                                (click)="setZoom('week')">Semaine</button>

                            <button class="uk-button uk-button-small uk-border-pill round-button"
                                [class.round-button-toggle]="zoomLevel === 'month'"
                                (click)="setZoom('month')">Mois</button>
                            <button class="uk-button uk-button-small planner-today-btn uk-margin-small-left"
                                (click)="goToToday()">Aujourd'hui</button>
                        </div>

                        <div class="planner-loader">
                            <div *ngIf="loading" uk-spinner="ratio: 0.7"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Toolbar -->

        <div class="planner-body uk-flex">

            <!-- Calendar container -->
            <div class="planner-calendar-wrap uk-width-expand">
                <div #calendarEl class="planner-calendar-el"></div>
                <div *ngIf="!loading && vehicles?.length === 0"
                    class="uk-text-center uk-margin-medium-top uk-text-muted">
                    Aucun véhicule trouvé pour cet opérateur.
                </div>
            </div>

            <!-- Booking form panel (create mode only, shown after slot selection) -->
            <div class="planner-form-panel" *ngIf="mode === 'create' && showForm && selection">
                <div class="uk-card uk-card-default planner-form-card">

                    <div class="uk-card-body planner-form-body">
                        <h2 class="main-title bold color-grey uk-margin-small-bottom">Nouvelle<br>réservation</h2>

                        <div class="uk-form-stacked">

                            <!-- Vehicle (read-only) -->
                            <div class="uk-margin">
                                <label class="label">Véhicule</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                        [value]="selection.vehicleName" disabled>
                                </div>
                            </div>

                            <!-- Station (read-only, shown only when available) -->
                            <div class="uk-margin" *ngIf="selection.stationName">
                                <label class="label">Station</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <input class="input alt color-cold-grey bold uk-width-1-1" type="text"
                                        [value]="selection.stationName" disabled>
                                </div>
                            </div>

                            <!-- Start datetime -->
                            <div class="uk-margin">
                                <label class="label">Début</label>
                                <div class="uk-form-controls uk-margin-small-top uk-flex planner-datetime-row">
                                    <input class="input alt color-cold-grey bold" type="date"
                                        [(ngModel)]="formBeginDate" (change)="onBeginChange()">
                                    <input class="input alt color-cold-grey bold planner-time-input" type="time"
                                        [(ngModel)]="formBeginTime" (change)="onBeginChange()">
                                </div>
                            </div>

                            <!-- End datetime -->
                            <div class="uk-margin">
                                <label class="label">Fin</label>
                                <div class="uk-form-controls uk-margin-small-top uk-flex planner-datetime-row">
                                    <input class="input alt color-cold-grey bold" type="date"
                                        [(ngModel)]="formEndDate" (change)="onEndChange()">
                                    <input class="input alt color-cold-grey bold planner-time-input" type="time"
                                        [(ngModel)]="formEndTime" (change)="onEndChange()">
                                </div>
                            </div>

                            <!-- Comment -->
                            <div class="uk-margin">
                                <label class="label">Commentaire</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <textarea class="input alt color-cold-grey bold uk-width-1-1" rows="2"
                                        [(ngModel)]="formComment" placeholder="Commentaire (optionnel)"></textarea>
                                </div>
                            </div>

                            <!-- Error message -->
                            <div *ngIf="submitError" class="uk-alert uk-alert-danger uk-margin-small">
                                {{ submitError }}
                            </div>

                        </div>
                    </div>

                    <div class="uk-modal-footer">
                        <p class="uk-text-right">
                            <button class="button bold" type="button" (click)="clearSelection()">
                                Annuler
                            </button>
                            <button class="button bold uk-margin-small-left" type="button"
                                [disabled]="!canSubmit || submitting" (click)="submit()">
                                <span *ngIf="!submitting">Ajouter</span>
                                <span *ngIf="submitting"><span uk-spinner="ratio: 0.6"></span></span>
                            </button>
                        </p>
                    </div>

                </div>
            </div>

        </div><!-- /planner-body -->

        <!-- Legend -->
        <div class="uk-margin-bottom uk-margin-top planner-legend planner-inset">
            <span class="legend-dot" style="background:#86E3BA;"></span>
            <span class="uk-text-small uk-margin-small-right">À venir</span>
            <span class="legend-dot" style="background:#F7A72A;"></span>
            <span class="uk-text-small uk-margin-small-right">En cours</span>
            <span class="legend-dot" style="background:#eeeeee;border:1px solid #ccc;"></span>
            <span class="uk-text-small uk-margin-small-right">Terminé</span>
            <span class="legend-dot" style="background:#ff4949;"></span>
            <span class="uk-text-small uk-margin-small-right">Annulé</span>
            <span class="legend-dot" style="background:#176bc1;"></span>
            <span class="uk-text-small uk-margin-small-right">Nouvelle réservation</span>
            <span *ngIf="idAccountTarget" class="uk-text-small uk-text-muted">
                · Opaque = cet utilisateur
            </span>
        </div>

    </div><!-- /planner-body-full -->
